import React, {useEffect} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {setAssignQuotePopupCustomer} from "../../../actions/assignPopupFunctions";
import AssignQuoteVirtualizedList from "./assignQuoteVirtualizedList";
import {customerInterface} from "./assignQuoteInterfaces";
import AssignPopupContext from './assignPopupContext';
import {CONTENT_TYPES} from "./assignQuoteConstants";
import {getCustomerById} from "../../../api/user-api";
import Misc from "../../../misc/misc";
import {restorePaymentInfo} from "../../../actions/paymentFunctions";
import {loaderDisable} from "../../ui/loaderView";
import {IS_OFFLINE_MODE} from "../../../config";

const AssignQuoteCustomersList = (props) => {

  const {customersList, setAssignQuotePopupCustomer, assignQuotePopupCustomer, userInfo, contentDimensions, activeTheme,
    changeContext, hideEmployeesList, setContentType, restorePaymentInfo} = props;

  useEffect(() => {
    if (userInfo && userInfo.email && !assignQuotePopupCustomer) {
      const customerSelected = customersList.find(customer => customer.email === userInfo.email);
      if (customerSelected) {
        setAssignQuotePopupCustomer(customerSelected);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo.email]);

  const handleCustomerClick = async (customerSelected) => {
    setAssignQuotePopupCustomer(customerSelected);
    changeContext({customerError: ""});
    if (!IS_OFFLINE_MODE && customerSelected && (!assignQuotePopupCustomer || (assignQuotePopupCustomer.id !== customerSelected.id))) {
      const responseCustomer = await getCustomerById({
        customerId: customerSelected.id,
      });
      loaderDisable();
      restorePaymentInfo({
        billingAddress: Misc.parseAddressResponseObject(
          responseCustomer && responseCustomer.address ? responseCustomer.address : {}
        ),
        shippingAddress: Misc.parseAddressResponseObject(
          responseCustomer && responseCustomer.shipping ? responseCustomer.shipping : {}
        )
      })
    }
  }

  const editCustomerClick = (customerSelected) => {
    setContentType(CONTENT_TYPES.shippingEdit);
    changeContext({customerSelected});
  }

  return (
    <AssignPopupContext.Consumer>
      {/*{({context, setContext}) => (*/}
      {({customerError}) => (
        <AssignQuoteVirtualizedList
          hideEmployeesColumn={hideEmployeesList}
          editCustomerClick={editCustomerClick}
          activeTheme={activeTheme}
          contentDimensions={contentDimensions}
          renderList={customersList}
          activeEntity={assignQuotePopupCustomer}
          selectEntity={handleCustomerClick}
          noEntitiesFound="assignPopup.noCustomersFound"
          title="assignPopup.customersTitle"
          errorMessage={customerError}
        />
      )}
    </AssignPopupContext.Consumer>
  )
};

AssignQuoteCustomersList.propTypes = {
  customersList: PropTypes.arrayOf(PropTypes.shape(customerInterface)).isRequired,
  assignQuotePopupCustomer: PropTypes.shape(customerInterface),
  contentDimensions: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
}

const mapStateToProps = (store) => {
  const {activeTheme} = store.serverState;
  return {
    assignQuotePopupCustomer: store.assignQuoteState.assignQuotePopupCustomer,
    userInfo: store.userState.userInfo,
    activeTheme,
  };
};

const mapDispatchToProps = {
  setAssignQuotePopupCustomer,
  restorePaymentInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignQuoteCustomersList)

